var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.972,
    height: 68.609,
    viewBox: "0 0 77.972 68.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "college-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36754",
    "data-name": "Group 36754",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36753",
    "data-name": "Group 36753",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64995",
    "data-name": "Path 64995",
    d: "M365.825,861.193v6.615a1.6,1.6,0,0,0,1.6,1.6h6.583a1.579,1.579,0,0,0,1.582-1.6v-6.615a1.633,1.633,0,0,0-.479-1.15l-3.291-3.18a1.582,1.582,0,0,0-2.221,0l-3.291,3.18A1.633,1.633,0,0,0,365.825,861.193Zm3.2.671,1.694-1.646,1.694,1.646v4.346h-3.387Z",
    transform: "translate(-307.374 -810.592)",
    fill: "#e2c603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M219.449,805.537a1.582,1.582,0,0,0-2.269,0l-3.291,3.307a1.545,1.545,0,0,0-.463,1.118v4.905a1.6,1.6,0,0,0,1.6,1.6h6.583a1.6,1.6,0,0,0,1.6-1.6v-4.905a1.572,1.572,0,0,0-.463-1.118Zm.559,7.733h-3.387v-2.636l1.694-1.694,1.694,1.694Z",
    transform: "translate(-179.324 -767.446)",
    fill: "#e2c603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64997",
    "data-name": "Path 64997",
    d: "M64.8,856.863l-3.291,3.18a1.634,1.634,0,0,0-.479,1.15v6.615a1.6,1.6,0,0,0,1.6,1.6H69.19a1.592,1.592,0,0,0,1.6-1.6v-6.615a1.634,1.634,0,0,0-.479-1.15l-3.291-3.18A1.582,1.582,0,0,0,64.8,856.863Zm2.812,9.347H64.221v-4.346l1.694-1.646,1.694,1.646Z",
    transform: "translate(-51.274 -810.592)",
    fill: "#e2c603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M213.888,716.745a1.545,1.545,0,0,0-.463,1.118v4.905a1.6,1.6,0,0,0,1.6,1.6h6.583a1.592,1.592,0,0,0,1.6-1.6v-4.905a1.572,1.572,0,0,0-.463-1.118l-3.291-3.307a1.582,1.582,0,0,0-2.269,0Zm6.12,1.773v2.652h-3.387v-2.652l1.694-1.694Z",
    transform: "translate(-179.324 -690.062)",
    fill: "#e2c603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64999",
    "data-name": "Path 64999",
    d: "M77.5,614.222h0l-20.1-19.6a1.616,1.616,0,0,0-2.029-.176L51.4,597.174l-10.833-11.84V582.65H53.594a1.6,1.6,0,0,0,1.6-1.6v-9.794a1.6,1.6,0,0,0-1.6-1.6H38.99a1.6,1.6,0,0,0-1.6,1.6v14.077L26.352,597.414l-4.362-2.972a1.6,1.6,0,0,0-2.029.192l-16.2,16.3L.467,614.238a1.591,1.591,0,0,0,0,2.253,1.628,1.628,0,0,0,1.118.463,1.586,1.586,0,0,0,1.134-.479l.559-.559v20.755a1.6,1.6,0,0,0,1.6,1.6H73.071a1.6,1.6,0,0,0,1.6-1.6V615.948l.575.559a1.583,1.583,0,0,0,1.118.447,1.622,1.622,0,0,0,1.15-.479A1.591,1.591,0,0,0,77.5,614.222ZM40.588,572.856H52.012v6.6H40.588ZM18.427,608.438a1.607,1.607,0,0,0,2.253-.1l2.093-2.285v29.016H6.475V612.7h.016l14.8-14.891,2.892,1.965-5.848,6.407A1.607,1.607,0,0,0,18.427,608.438ZM42.266,635.09H35.715v-6.5l3.275-2.876,3.275,2.876Zm9.747-.016H45.461v-7.222a1.591,1.591,0,0,0-.543-1.2h0l-4.873-4.282a1.6,1.6,0,0,0-2.109,0l-4.873,4.282a1.567,1.567,0,0,0-.543,1.2v7.222H25.968V602.559L38.99,588.322l13.022,14.236v32.515Zm7.621-28.856-6.072-6.631,2.525-1.742,15.387,15V635.09H55.192V606.074l2.093,2.285a1.592,1.592,0,0,0,1.182.527,1.61,1.61,0,0,0,1.071-.415A1.579,1.579,0,0,0,59.634,606.218Z",
    transform: "translate(0 -569.66)",
    fill: "#e2c603"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileLogo1);
export default __webpack_public_path__ + "static/media/tile-logo1.0e2f2f099eb69bacd0925867d8ee753c.svg";
export { ForwardRef as ReactComponent };